import { useRoutineStore } from '@/stores/routineStore';
import { RoutineCompressionDialog } from './RoutineCompressionDialog';

interface Props {
  routineId: string;
  onClose: () => void;
}

/** Adapts the pure compression dialog to the store, for the AI `compress_routine`
 * command (no RoutineBuilder draft is open in that path, so writing the store is
 * correct). */
export function RoutineCompressionDialogConnector({ routineId, onClose }: Props) {
  const routine = useRoutineStore((s) => s.routines.find((r) => r.id === routineId));
  const updateRoutine = useRoutineStore((s) => s.updateRoutine);
  if (!routine) return null;
  return (
    <RoutineCompressionDialog
      steps={routine.steps}
      routineName={routine.name}
      onApply={(steps) => updateRoutine(routine.id, { steps })}
      onClose={onClose}
    />
  );
}
